import asyncRetry from "async-retry";
//#region src/Retry/retry.ts
var RETRY_OPTIONS = {
	retries: 4,
	minTimeout: 200
};
async function retry(resolver, options = {}) {
	return asyncRetry(resolver, {
		...RETRY_OPTIONS,
		...options
	});
}
//#endregion
export { retry as t };

//# sourceMappingURL=Retry-bE6F5VEG.js.map